// extracted by mini-css-extract-plugin
export default {"cls1":"MultiPaperNewsStory-cls1_HjZ","cls2":"MultiPaperNewsStory-cls2_RwN MultiPaperNewsStory-cls1_HjZ"};